import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { getNumberValidFilter } from '@anytag/shared-utils';
import { GenderField, KeywordField, InfluencerTabField, CountriesField } from '../../shared';
import { BasicFilterDefaultProps } from '../../schemaTypes';
import { InstagramInfluencersFilterFormKeys, InstagramInfluencersFilterFormValues } from '../schemaTypes';
import { AdvancedFilter } from './AdvancedFilter';

export const BasicFilter = ({ onSubmit, isEngagementPage, isPackagePage }: BasicFilterDefaultProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<InstagramInfluencersFilterFormValues>();

  const values = watch();
  const numOfValidFilter = getNumberValidFilter<InstagramInfluencersFilterFormKeys>(values, [
    'tab',
    'keyword',
    'genders',
    'includeIds',
    'countryIds'
  ]);

  return (
    <Form.Fields>
      <InfluencerTabField isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} onSubmit={onSubmit} />
      <KeywordField placeholder={t<string>('Search.InfluencerSocialFilter')} onSubmit={onSubmit} searchByCategories />
      <GenderField onSubmit={onSubmit} css={{ maxWidth: '123px' }} />
      <CountriesField onSubmit={onSubmit} />
      <AdvancedFilter count={numOfValidFilter} onSubmit={onSubmit} />
    </Form.Fields>
  );
};
